export const applicableGroups = [
  { _id: 'Class', title: 'Class(es)' },
  { _id: 'Staff', title: 'Staff' },
  { _id: 'Students', title: 'Student(s)' }
]
